import CardNavigator from 'features/cardManagement/screens/CardNavigator/CardNavigator';
import React from 'react';

export default function Page() {
  return <CardNavigator />;
}
